export default {"src":"/_next/static/media/magnifier-people.b302a0a1.svg","height":76,"width":85};